import { render } from "./AdminGlobalPage.vue?vue&type=template&id=2b471f1b"
import script from "./AdminGlobalPage.vue?vue&type=script&lang=js"
export * from "./AdminGlobalPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__